import { DisplayFormErrors, InputField,  VerticalForm } from "melco-shared-logic";
import { FullWidthSpace, Button, Space, SaveIcon,  } from "melco-ui";
import { DebugForm } from "../../form/DebugForm";
import { useFormikContext } from "formik";
import styled from "styled-components";
import { DisplaySuppliersDropDown } from "../../dropdown/DisplaySuppliersDropDown";
import { useTranslation } from "react-i18next";


type DisplaySupplierProductAddFormProps = {
  
};

const Right = styled(Space)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 50px;
`;

export const DisplaySupplierProductAddForm: React.FC<
  DisplaySupplierProductAddFormProps
> = ({  }) => {
 
  

  const { t } = useTranslation();
  const {submitForm} = useFormikContext();

  return (
    <>
      
    <VerticalForm>
      <Right direction="vertical" size="small">
         <Space size="small">
            <Button 
            name="save"
            icon={<SaveIcon />}
            type="primary"
              onClick={()=>submitForm()}>
                {t("supplierproducts.form.save")}
                </Button>
          </Space>
         </Right>

        <FullWidthSpace direction="vertical">
          <div>
            <DisplayFormErrors />
            <DisplaySuppliersDropDown />
           <InputField
              name="name"
              label={t("supplierproducts.form.name")}
            />
          <InputField
              name="code"
              label={t("supplierproducts.form.code")}
            />
           
           
          </div>
        </FullWidthSpace>

      </VerticalForm>

      {false && <DebugForm />}
    </>
  );
};
